import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { Card, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiTypography from "components/SuiTypography";
import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";

import { AccountContext } from "context/account";
import api from "services/api";
import toast from "react-hot-toast";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import Avatar from "@mui/material/Avatar";

const BlogCard = ({ index, blog, handleClick = () => {}, ...rest }) => {
  const [isHover, setIsHover] = useState(false);

  const account = useContext(AccountContext);
  const navigate = useNavigate();
  const primaryImage = { url: blog?.mainimg, type: "image/*", name: blog.title };
  return (
    <div style={{ border: "solid 1px #e3e3e3" }}>
      <div onMouseEnter={() => setIsHover(true)} onMouseLeave={() => setIsHover(false)}>
        <SuiBox display="flex" alignItems="center" gap={0.5} sx={{ cursor: "pointer", p: 0.5 }}>
          <Avatar
            src={blog?.metadata?.avatar}
            sx={{
              width: 26,
              height: 26,
              cursor: "pointer",
            }}
            onClick={() =>
              account?.id
                ? navigate(`/wall/portfolio/${blog.owner_id}`)
                : navigate(`/public/portfolio/${blog.owner_id}`)
            }
          />
          <SuiTypography
            variant="body1"
            textTransform="none"
            color="dark"
            sx={{
              fontWeight: "bold",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: "1",
              WebkitBoxOrient: "vertical",
              cursor: "pointer",
            }}
            onClick={() =>
              account?.id
                ? navigate(`/wall/portfolio/${blog.owner_id}`)
                : navigate(`/public/portfolio/${blog.owner_id}`)
            }
          >
            {blog?.username}
          </SuiTypography>{" "}
        </SuiBox>
        <Tooltip title={blog.title}>
          <SuiTypography
            variant="body1"
            textTransform="none"
            sx={{
              px: 1,
              fontWeight: "bold",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: "1",
              WebkitBoxOrient: "vertical",
            }}
          >
            {blog.title}
          </SuiTypography>
        </Tooltip>
        <SuiTypography
          variant="body2"
          textTransform="none"
          sx={{
            px: 1,
            lineHeight: 1,
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: "2",
            WebkitBoxOrient: "vertical",
            minHeight: 24,
          }}
        >
          {blog.summary}
        </SuiTypography>
        <SuiBox
          onClick={(e) => handleClick(e, blog)}
          sx={{
            cursor: "pointer",
            backgroundImage: ({ functions: { rgba, linearGradient }, palette: { gradients } }) =>
              `${linearGradient(
                rgba(gradients.secondary.state, 0.1),
                rgba(gradients.secondary.state, 0.1)
              )}`,
            boxShadow: ({ boxShadows: { lg } }) => (isHover ? lg : "none"),
            overflow: "hidden",
            position: "relative",
            display: "flex",
            minWidth: 0,
            width: "100%",

            ...rest?.sx,
          }}
          className="hover-parent"
        >
          <ImageCardWrapper
            data={primaryImage}
            height={180}
            width={"auto"}
            onDragStart={(e) => e.preventDefault()}
            draggable={false}
            resizeLimit={"0"}
            {...rest}
          />
        </SuiBox>
      </div>

      <SuiBox display="flex" justifyContent="space-between" alignItems="center">
        <SuiBox
          sx={{
            width: "50%",
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            gap: 0.5,
            border: "solid 1px #e3e3e3",
            cursor: "pointer",
            py: 1,
            "&:hover": {
              webkitBoxShadow: "0 0.25rem 1rem rgba(48, 55, 66, 0.15)",
              boxShadow: "0 4px 16px rgba(48, 55, 66, 0.15)",
            },
          }}
        >
          <ThumbUpOutlinedIcon color="text" />{" "}
          <SuiTypography color="text" variant="body2">
            Like
          </SuiTypography>
        </SuiBox>
        <SuiBox
          sx={{
            width: "50%",
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            gap: 0.5,
            border: "solid 1px #e3e3e3",
            cursor: "pointer",
            py: 1,
            "&:hover": {
              webkitBoxShadow: "0 0.25rem 1rem rgba(48, 55, 66, 0.15)",
              boxShadow: "0 4px 16px rgba(48, 55, 66, 0.15)",
            },
          }}
        >
          <ChatBubbleOutlineOutlinedIcon color="text" />{" "}
          <SuiTypography color="text" variant="body2">
            Comment{" "}
          </SuiTypography>
        </SuiBox>
      </SuiBox>
    </div>
  );
};
export default BlogCard;
